import { render } from "./AddDiagnosisModal.vue?vue&type=template&id=70decb2a&scoped=true"
import script from "./AddDiagnosisModal.vue?vue&type=script&lang=js"
export * from "./AddDiagnosisModal.vue?vue&type=script&lang=js"

import "./AddDiagnosisModal.vue?vue&type=style&index=0&id=70decb2a&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70decb2a"]])

export default __exports__